<template>
  <div id="infoFillingPage">
    <div>
      <header>其他信息</header>
      <ul>
        <li style="height: 100px;">
          <div class="tit" style="width: 100%;height: 50px;">
            <span style="width: 40%">详细地址：</span>
            <span style="color: #666666">（例如：广东省广州市越秀区中山七路208号301室）</span>
          </div>
          <div class="sInfo" style="width: 100%;height: 50px;">
            <input style="text-align: left" type="text" placeholder="请填写详细地址，精确到门牌号" v-model="address" />
          </div>
        </li>
        <li>
          <div class="tit">房屋已用年限：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入房屋已用年限(1-30年)" v-model="bulidingAge" maxlength="2" onkeyup="value=value.replace(/[^\d]/g,'')" />
          </div>
        </li>
        <li class="arrow">
          <div class="tit">房屋结构类型：</div>
          <div class="sInfo select">
            <el-select @change="selectPhoneType" v-model="bulidingStructer" placeholder="请选择">
              <el-option
                :value="'建筑等级一：钢混、钢结构'"
                size="small">
              </el-option>
            </el-select>
          </div>
        </li>
        <li class="arrow">
          <div class="tit">防盗抢设施：</div>
          <div class="sInfo select">
            <el-select @change="selectPhoneType" v-model="buildingSaftyDevice" placeholder="请选择">
              <el-option
                :value="'其他'"
                size="small">
              </el-option>
            </el-select>
          </div>
        </li>
      </ul>
    </div>
    <div>
      <header>权益人信息</header>
      <ul>
        <li>
          <div class="tit">姓名：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入姓名" v-model="insuredName" />
          </div>
        </li>
        <li>
          <div class="tit">身份证号：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入身份证号" v-model="insuredIdCard" maxlength="18" onKeyUp="value=value.replace(/[\W]/g,'')" />
          </div>
        </li>
        <li>
          <div class="tit">手机号：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入手机号" v-model="insuredMobile" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')" />
          </div>
        </li>
      </ul>
    </div>
    <div class="claim">
      <el-button @click="submitOrder">立即领取权益</el-button>
    </div>
  </div>
</template>

<script>
    export default {
      name: "familyPropertyInsurance_infoFillingPage",
      data() {
        return {
          skuList: [],
          rightsToken: '',
          skuId: '',
          phoneType: '',
          //-- 其他信息
          address: '',
          bulidingAge: '',
          bulidingStructer: '建筑等级一：钢混、钢结构',
          buildingSaftyDevice: '其他',
          //-- 受益人信息
          insuredName: '',
          insuredIdCard: '',
          insuredMobile: '',
          //-- 权益数据
          cpPhoneMoney: '',
        }
      },
      methods: {
        selectPhoneType(e){

        },
        //-- 获取权益数据
        getRightsInfo(){
          let that = this;
          let loading = that.Loading.service({fullscreen: true});
          that.axios.post('/management/unicom/getRightsInfo', {rightsToken: that.rightsToken}).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;

            if (data.success) {
              const {cpPhoneMoney, phoneNum, skuList} = data.datas;
              that.skuList = skuList;
              that.cpPhoneMoney = cpPhoneMoney;
              that.insuredMobile = phoneNum;
            }else {
              that.$$.alert({
                message: data.msg,
                onOk: function () {
                  that.$router.go(-1);
                }
              });
            }
          });
        },
        //-- 领取权益
        submitOrder(){
          let that = this;
          const {rightsToken, address, bulidingAge, bulidingStructer, buildingSaftyDevice, insuredName, insuredIdCard, insuredMobile} = that;

          //-- 校验
          const errorMsg = that.validationForm();
          if(that.$$.isValidObj(errorMsg)) return that.$message.error(errorMsg);

          // 其他信息
          let extendJson = {bulidingAge, bulidingStructer, buildingSaftyDevice};

          // 受益人信息
          let insuredList = [{
            insuredName,
            insuredIdCard,
            insuredMobile,
          }];

          let params = {
            "rightsToken": rightsToken,
            "insureData": JSON.stringify({"insureAddress": address}),
            "extendJson": JSON.stringify(extendJson),
            "insuredList": JSON.stringify(insuredList),
            "skuId": that.skuId
          };

          // console.log(params);
          // return;

          let loading = that.Loading.service({fullscreen: true});
          that.axios.post('/management/unicom/submitOrder', params).then((response) => {
            that.$nextTick(() => loading.close());
            let data = response.data;

            if (data.success) {
              this.$$.alert({
                message: "权益领取成功~",
                onOk: function () {
                  console.log(data);
                  that.$router.go(-1);
                }
              });
            }else {
              that.errorPrompt = data.msg;
            }
          });
        },
        //-- 校验
        validationForm(){
          let that = this;
          const {address, bulidingAge, bulidingStructer, buildingSaftyDevice, insuredName, insuredIdCard, insuredMobile} = that;

          if(!that.$$.isValidObj(address)) return "请输入详细地址~";
          if(!that.$$.isValidObj(bulidingAge)) return "请输入房屋已用年限~";
          if (parseInt(bulidingAge) > 30) return "房屋已用年限不能大于30年~";

          if(!that.$$.isValidObj(bulidingStructer)) return "请选择房屋结构类型~";
          if(!that.$$.isValidObj(buildingSaftyDevice)) return "请选择防盗抢设施~";

          // 获取SkuId
          for (let i in that.skuList){
            let unit = that.skuList[i];

            that.skuId = unit['skuId'];
          }

          if(!that.$$.isValidObj(insuredName)) return "请输入姓名~";
          if (that.$$.constant.chineseNameReg.test(insuredName) === false) return "姓名不正确!";
          if(!that.$$.isValidObj(insuredIdCard)) return "请输入身份证号~";
          if (that.$$.constant.beInsureIdTypeOneReg.test(insuredIdCard) === false) return "身份证格式不正确!";
          if(!that.$$.isValidObj(insuredMobile)) return "请输入手机号~";
          if (that.$$.constant.phoneReg.test(insuredMobile) === false) return "手机号格式不正确!";
        }
      },
      mounted() {
        let that = this;

        that.rightsToken = that.$route.query.rightsToken;

        //-- 获取权益数据
        if (that.$$.isValidObj(that.rightsToken)) {
          that.getRightsInfo();
        }else {
          that.$$.alert({
            message: '参数有误，请重新领取权益!',
            onOk: function () {
              that.$router.go(-1);
            }
          });
        }
      }
    }
</script>

<style scoped>
  #infoFillingPage header{
    height: 50px;
    line-height: 50px;
    font-size: 15px;
    font-weight: bold;
    padding-left: 16px;
    color: #666666;
    background: #F5F5F5;
  }

  #infoFillingPage li{
    height: 50px;
    min-height: 50px;
    margin: 0 16px;
    font-size: 14px;
    border-bottom: 1px solid #F2F4F7;
    position: relative;
  }

  .tit {
    width: 40%;
    height: 100%;
    letter-spacing: 1px;
    float: left;
    display: flex;
    align-items: center
  }

  .sInfo {
    width: 59%;
    height: 100%;
    color: #CCCCCC;
    background: #ffffff;
    float: right;
    text-align: right;
    display: flex;
    align-items: center;
  }
  .sInfo div{
    width: 100%;
  }
  .sInfo.active{
    color: #ff7052;
  }

  .arrow .sInfo{
    padding-right: 5%;
  }

  .arrow:after {
    content: '';
    position: absolute;
    right: 0%;
    top: 50%;
    margin-top: -5px;
    display: block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #ff7052;
    border-bottom: 2px solid #ff7052;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  input::-webkit-input-placeholder{
    color: #CCCCCC;
    font-weight: 400;
    font-size: 14px;
  }
  input{
    width: 100%;
    text-align: right;
    font-size: 14px;
    color: #ff7052;
  }

  .reminder input{
    width: calc(100% - 30px);
  }
  .reminder-image{
    margin-left: 18px;
    width: 12px;
    height: 12px;
    background: url("../../../../static/images/product/brokenScreenInsurance/reminder.png") no-repeat right /100% 100%;
  }
  .reminder .important{
    font-size: 12px;
    color: #FA6E50;
    font-weight: bold;
    position: absolute;
    bottom: 10px;
    left: 0;
  }

  .sInfo /deep/ .el-input__inner {
    color: #FA6E50 !important;
    text-align: right !important;
    font-size: 14px!important;
  }

  .claim{
    width: 100%;
    height: 100px;
    padding: 30px 10%;
  }
  .claim>button{
    width: 100%;
    height: 40px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    background: #FF7052;
    border-radius: 4px;
    border: none;
    clear: both;
  }

  /* 弹窗提示 start */
  .el-dialog__wrapper /deep/ .el-dialog{
    margin-top: 30vh!important;
    border-radius: 15px;
    position: relative;
  }

  .el-dialog__wrapper /deep/ .el-dialog__title{
    color: #FA6E50;
    font-size: 16px;
    font-weight: bold;
  }
  .el-dialog__wrapper /deep/ .el-dialog__body{
    padding: 0px!important;
    width: 100%;
    text-align: center;
    position: absolute;
    border-radius: 15px;
    top: 0;
    left: 0;
  }
  .el-dialog__wrapper /deep/ .el-dialog__headerbtn{
    z-index: 999;
  }

  .head{
    width: 100%;
    line-height: 50px;
    border-radius: 15px 15px 0 0;
    padding: 15px 0 10px;
    font-weight: bold;
    background: linear-gradient(0deg, #FFF9F8 0%, #FFE3DD 100%);
    letter-spacing: 1px;
  }
  .title{
    color: #FA6E50;
    font-size: 16px;
    display: inline-block;
    vertical-align: middle;
  }
  .tipBell{
    width: 20px;
    height: 23px;
    display: inline-block;
    vertical-align: middle;
  }

  .promptContent{
    line-height: 26px;
    padding: 10px 0 20px 15%;
    background: #FFFFFF;
    border-radius: 0 0 15px 15px;
    text-align: left;
  }
  .promptContent>div:nth-child(1),
  .promptContent>div:nth-child(3){
    color: #999999;
    font-size: 12px;
  }
  .promptContent>div:nth-child(2),
  .promptContent>div:nth-child(4){
    color: #666666;
    font-size: 13px;
    font-weight: bold;
    margin: 0 0 5px 30px;
  }
  /* 弹窗提示 end */

  .select /deep/ .el-input__inner {
    border: 0 !important;
    padding-right: 0px!important;
    background: #ffffff!important;
  }

  .select /deep/ .el-input__suffix{
    display: none;
  }

  /deep/ .el-message-box__wrapper{
    width: 24rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/familyPropertyInsurance/infoFillingPage.vue